import {
  W, SAFE_TOP, SAFE_BOTTOM, EMERALD, INK, INK_MUTED, PAD_X,
  newCard, drawDofi, drawFooter, toPng,
} from '@/utils/cardCanvas';

// ════════════════════════════════════════════════════════════════
// Карточки приглашения и подарка (07.10.2026). До этого «Пригласить друга»
// и «Подарить» отправляли в Telegram голый текст со ссылкой — Слава: «скучно,
// везде, где делишься, должна быть красивая карточка».
// ════════════════════════════════════════════════════════════════

function features(ctx: CanvasRenderingContext2D, y: number): number {
  const rows = [
    ['📸', 'Сфотографировал — калории посчитаны'],
    ['🧠', 'Дофи помнит тебя и подскажет, что съесть'],
    ['🌈', 'Витамины и разбор недели — сами'],
  ];
  ctx.textAlign = 'left';
  for (const [emoji, text] of rows) {
    ctx.font = '44px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif';
    ctx.fillStyle = INK;
    ctx.fillText(emoji, PAD_X, y);
    ctx.font = '400 33px Inter, system-ui, sans-serif';
    ctx.fillStyle = INK_MUTED;
    ctx.fillText(text, PAD_X + 72, y - 2);
    y += 78;
  }
  ctx.textAlign = 'center';
  return y;
}

function bigLine(ctx: CanvasRenderingContext2D, value: string, unit: string, y: number): number {
  ctx.textAlign = 'center';
  ctx.fillStyle = EMERALD;
  ctx.font = '700 150px "Space Grotesk", Inter, system-ui, sans-serif';
  ctx.shadowColor = 'rgba(16,229,142,0.45)';
  ctx.shadowBlur = 40;
  ctx.fillText(value, W / 2, y);
  ctx.shadowBlur = 0;
  y += 70;
  ctx.fillStyle = INK;
  ctx.font = '500 42px Inter, system-ui, sans-serif';
  ctx.fillText(unit, W / 2, y);
  return y + 100;
}

export async function renderInviteCard(opts: { name?: string | null; refCode?: string | null }): Promise<Blob> {
  const { canvas, ctx } = await newCard();
  await drawDofi(ctx, { cy: SAFE_TOP + 200, size: 320, pose: 'joy', badge: '👋' });

  let y = SAFE_TOP + 450;
  ctx.textAlign = 'center';
  ctx.fillStyle = INK;
  ctx.font = '700 60px "Space Grotesk", Inter, system-ui, sans-serif';
  // Перенос задан руками: автоматический рвал «Slava / Health»
  const lines = opts.name ? [`${opts.name} зовёт тебя`, 'в Slava Health'] : ['Зову тебя', 'в Slava Health'];
  for (const line of lines) { ctx.fillText(line, W / 2, y); y += 72; }
  y += 120;
  y = bigLine(ctx, '+7 дней', 'бесплатно по моей ссылке', y);
  y = features(ctx, y + 10);

  const footerH = opts.refCode ? 160 : 116;
  drawFooter(ctx, Math.max(y + 40, SAFE_BOTTOM - footerH), opts.refCode);
  return toPng(canvas);
}

export async function renderGiftCard(opts: { name?: string | null; plan: 'month' | 'year' }): Promise<Blob> {
  const { canvas, ctx } = await newCard();
  await drawDofi(ctx, { cy: SAFE_TOP + 200, size: 320, pose: 'proud', badge: '🎁' });

  let y = SAFE_TOP + 460;
  ctx.textAlign = 'center';
  ctx.fillStyle = INK;
  ctx.font = '700 72px "Space Grotesk", Inter, system-ui, sans-serif';
  ctx.fillText('Это тебе подарок', W / 2, y);
  y += 64;
  if (opts.name) {
    ctx.fillStyle = INK_MUTED;
    ctx.font = '500 38px Inter, system-ui, sans-serif';
    ctx.fillText(`с заботой — ${opts.name}`, W / 2, y);
  }
  y += 200;
  y = bigLine(ctx, opts.plan === 'year' ? 'Год' : '30 дней', 'заботы о себе в Slava Health — уже оплачено', y);
  y = features(ctx, y + 10);

  ctx.fillStyle = INK_MUTED;
  ctx.font = 'italic 400 36px Georgia, "Times New Roman", serif';
  ctx.fillText('«Просто открой — остальное я возьму на себя.»', W / 2, y + 30);

  drawFooter(ctx, Math.max(y + 110, SAFE_BOTTOM - 116), null);
  return toPng(canvas);
}
